export { default } from './EmDiaValeMaisFooter';
